(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    function initializeDropFooters(root) {
      const footers = [];

      if (root.matches && root.matches('[data-drop-footer]')) {
        footers.push(root);
      }

      if (root.querySelectorAll) {
        footers.push(...root.querySelectorAll('[data-drop-footer]'));
      }

      footers.forEach((footer) => {
        if (footer.dataset.ready === 'true') return;
        footer.dataset.ready = 'true';

        const desktop = window.matchMedia('(min-width: 768px)');
        const menus = footer.querySelectorAll('[data-drop-menu]');

        function updateMenus() {
          menus.forEach((menu) => {
            menu.open = desktop.matches;

            const summary = menu.querySelector('summary');

            if (desktop.matches) {
              summary.setAttribute('tabindex', '-1');
            } else {
              summary.removeAttribute('tabindex');
            }
          });
        }

        menus.forEach((menu) => {
          menu.querySelector('summary').addEventListener('click', (event) => {
            if (desktop.matches) event.preventDefault();
          });
        });

        updateMenus();

        function onChange() {
          if (!footer.isConnected) {
            desktop.removeEventListener('change', onChange);
            return;
          }

          updateMenus();
        }

        desktop.addEventListener('change', onChange);

        footer.querySelectorAll('[data-drop-select]').forEach((select) => {
          select.addEventListener('change', () => {
            if (!select.form) return;

            if (typeof select.form.requestSubmit === 'function') {
              select.form.requestSubmit();
            } else {
              select.form.submit();
            }
          });
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initializeDropFooters(document);
      }, { once: true });
    } else {
      initializeDropFooters(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeDropFooters(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
